import * as React from "react";
import { flatOrI18n, tSafe } from "../_helpers";
import { showGlobalSnackbar } from "../_services/snackbarService";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import classNames from "classnames";
import Dropzone from "react-dropzone";
import { useTranslation, Trans } from "react-i18next";
import "../css/style.css";
import { serverUrl } from "../_constants";
import TextFieldI18N from "../_components/TextFieldI18N";
import TextFieldHint from "../_components/TextFieldHint";

const LANG_LIST = ["ru", "en", "cn"];

export default function MemberDialog(props) {
  const [name, setName] = React.useState("");
  const [description, setDesc] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [city, setCity] = React.useState("");
  const [comm, setComm] = React.useState("");
  const [name_i18n, setNameI18N] = React.useState({});
  const [description_i18n, setDescI18N] = React.useState({});
  const [city_i18n, setCityI18N] = React.useState({});
  const [comment_i18n, setCommI18N] = React.useState({});
  const [count, setCount] = React.useState(0);

  const {
    handleClose,
    title,
    dialogOpen,
    dName,
    dPhone,
    dMail,
    dDesc,
    dComm,
    dCity,
    dNameI18N,
    dDescI18N,
    dCommI18N,
    dCityI18N,
    id,
    image,
    uploadImage,
    imageStatus,
    isMultilang,
    langList,
  } = props;

  const { t } = useTranslation();

  React.useEffect(() => {
    if (count === 0) {
      setPhone(dPhone);
      setName(dName);
      setDesc(dDesc);
      setCity(dCity);
      setEmail(dMail);
      setComm(dComm);
      setNameI18N(dNameI18N);
      setDescI18N(dDescI18N);
      setCityI18N(dCityI18N);
      setCommI18N(dCommI18N);
    }
  }, [
    count,
    dPhone,
    dName,
    dDesc,
    dCity,
    dMail,
    dComm,
    dCityI18N,
    dNameI18N,
    dCommI18N,
    dDescI18N,
  ]);

  function saveData(e) {
    e.preventDefault();

    // Годится любая заполненная вкладка, а не только русская: в китайской сборке
    // имя вводят на китайском, и диалог молча не сохранялся — ни ошибки, ни спикера.
    if (!flatOrI18n({ name, name_i18n })) {
      // Без этого нажатие «Сохранить» с пустым именем не делало ровным счётом
      // ничего: диалог оставался открытым, спикер не появлялся, причина неизвестна.
      showGlobalSnackbar(tSafe("site_fill_fields_name"), "warning");
      return;
    }

    {
      handleClose({
        name,
        phone,
        city,
        description,
        email,
        comment: comm,
        name_i18n,
        city_i18n,
        description_i18n,
        comment_i18n,
      });
      setCount(0);
    }
  }

  function cancelData() {
    handleClose("");
    setCount(0);
  }

  function onDrop(acceptedFiles, rejectedFiles) {
    if (acceptedFiles.length > 0) {
      uploadImage(acceptedFiles[0]);
    }
  }

  return (
    <Dialog open={dialogOpen}>
      <DialogTitle>{title}</DialogTitle>
      <form onSubmit={saveData}>
        <DialogContent>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Dropzone onDrop={onDrop} class="visually--hidden">
              {({ getRootProps, getInputProps, isDragActive }) => (
                <div
                  style={{
                    textAlign: "center",
                    verticalAlign: "center",
                    position: "relative",
                    width: 250,
                    height: 250,
                    maxWidth: "100%",
                    background: "#eee",
                    borderRadius: 5,
                    border: "1px solid #000",
                  }}
                  {...getRootProps()}
                  className={classNames("dropzone", {
                    "dropzone--isActive": isDragActive,
                  })}
                >
                  <input {...getInputProps()} />

                  {/* Показываем и выбранный файл: до сохранения диалога он живёт
                      как blob:-ссылка, у сохранённого — путь на сервере.
                      Раньше картинка рисовалась только при imageStatus === 0,
                      и после выбора файла рамка оставалась пустой с надписью
                      «файл загружен» (пункты 64 и 65 QA-таблицы). */}
                  {image && (
                    <img
                      src={image.startsWith("blob") ? image : serverUrl + image}
                      alt=""
                      className="object-cover"
                    />
                  )}
                  {/* Подпись центрируется по рамке флексом. Раньше её двигали
                      парой top/left с шириной 220 и внутренними отступами — при
                      content-box подложка вылезала за правый край рамки
                      (пункт 75 QA-таблицы). */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 15,
                      boxSizing: "border-box",
                      pointerEvents: "none",
                    }}
                  >
                    {imageStatus === 0 && !image && (
                      <p
                        style={{
                          fontSize: 12,
                          background: "#eee",
                          padding: 10,
                          borderRadius: 5,
                          margin: 0,
                          maxWidth: "100%",
                        }}
                      >
                        {t(isDragActive ? "dropzone_file_upload" : "dropzone_title_hint")}
                      </p>
                    )}
                    {imageStatus === 1 && !image && (
                      <p
                        style={{
                          fontSize: 12,
                          background: "#eee",
                          padding: 10,
                          borderRadius: 5,
                          margin: 0,
                          maxWidth: "100%",
                        }}
                      >
                        {t("dropzone_file_uploaded")}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </Dropzone>
          </div>
          <TextFieldI18N
            autoFocus={true}
            margin="dense"
            id="name"
            label={t("dialog_name")}
            fullWidth
            variant="standard"
            value={isMultilang ? name_i18n : name}
            required
            onChange={(e, tabName) => {
              if (isMultilang) {
                let tmpI18N = name_i18n;
                tmpI18N[tabName] = e.target.value;

                setNameI18N(tmpI18N);
                setName(tmpI18N["ru"]);
              } else {
                setName(e.target.value);
              }
              setCount(count + 1);
            }}
            langList={langList}
            isMultilang={isMultilang}
          />
          <TextFieldI18N
            margin="dense"
            id="desc"
            label={t("dialog_desc")}
            fullWidth
            variant="standard"
            value={isMultilang ? description_i18n : description}
            langList={langList}
            isMultilang={isMultilang}
            onChange={(e, tabName) => {
              if (isMultilang) {
                let tmpI18N = description_i18n;
                tmpI18N[tabName] = e.target.value;

                setDescI18N(tmpI18N);
                setDesc(tmpI18N["ru"]);
              } else {
                setDesc(e.target.value);
              }
              setCount(count + 1);
            }}
          />
          <TextFieldHint
            margin="dense"
            id="email"
            label={t("dialog_email")}
            fullWidth
            variant="standard"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setCount(count + 1);
            }}
          />
          <TextFieldHint
            margin="dense"
            id="phone"
            label={t("dialog_phone")}
            fullWidth
            variant="standard"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
              setCount(count + 1);
            }}
          />
          <TextFieldI18N
            margin="dense"
            id="phone"
            label={t("dialog_city")}
            fullWidth
            variant="standard"
            value={isMultilang ? city_i18n : city}
            langList={langList}
            isMultilang={isMultilang}
            onChange={(e, tabName) => {
              if (isMultilang) {
                let tmpI18N = city_i18n;
                tmpI18N[tabName] = e.target.value;

                setCityI18N(tmpI18N);
                setCity(tmpI18N["ru"]);
              } else {
                setCity(e.target.value);
              }
              setCount(count + 1);
            }}
          />
          <TextFieldI18N
            margin="dense"
            id="phone"
            label={t("dialog_comment")}
            fullWidth
            variant="standard"
            value={isMultilang ? comment_i18n : comm}
            multiline={true}
            langList={langList}
            isMultilang={isMultilang}
            onChange={(e, tabName) => {
              if (isMultilang) {
                let tmpI18N = comment_i18n;
                tmpI18N[tabName] = e.target.value;

                setCommI18N(tmpI18N);
                setComm(tmpI18N["ru"]);
              } else {
                setComm(e.target.value);
              }
              setCount(count + 1);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit">{t("btn_save")}</Button>
          <Button onClick={cancelData}>{t("btn_cancel")}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
